// extracted by mini-css-extract-plugin
export default {"footer":"footer__footer","partialLogo":"footer__partialLogo","text":"footer__text","versionWrapper":"footer__versionWrapper","portalName":"footer__portalName"};